/**
* @license Apache-2.0
*
* Copyright (c) 2022 The Stdlib Authors.
*
* Licensed under the Apache License, Version 2.0 (the "License");
* you may not use this file except in compliance with the License.
* You may obtain a copy of the License at
*
*    http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing, software
* distributed under the License is distributed on an "AS IS" BASIS,
* WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
* See the License for the specific language governing permissions and
* limitations under the License.
*/

'use strict';

/**
* Test if a string ends with the characters of another string.
*
* @module @stdlib/string/base/ends-with
*
* @example
* import endsWith from '@stdlib/string/base/ends-with';
*
* var str = 'Fair is foul, and foul is fair, hover through fog and filthy air';
*
* var bool = endsWith( str, 'air', str.length );
* // returns true
*
* bool = endsWith( str, 'fair', str.length );
* // returns false
*
* bool = endsWith( str, 'fair', 30 );
* // returns true
*
* bool = endsWith( str, 'fair', -34 );
* // returns true
*/

// MODULES //

import HAS_BUILTIN from './has_builtin.js';
import polyfill from './polyfill.js';
import main from './main.js';


// MAIN //

var endsWith;
if ( HAS_BUILTIN ) {
	endsWith = main;
} else {
	endsWith = polyfill;
}


// EXPORTS //

export default endsWith;
